import React, {useState} from "react";
import Accordion from "../../components/accordion/Accordion";
import {cleanDrops} from "../../hooks/helpers";
import ImgEncabezado from "../../components/imagenEncabezado/ImgEncabezado";
import ApplicantsTable from "./components/ApplicantsTable";

export default function EnterpriseProgramView({theme}) {
   const [status, setStatus] = useState([0, 0]);

   const changeMode = (newVal, key) => {
      let nStatus = cleanDrops(status.length, key, newVal);
      setStatus([...nStatus]);
   };

   return (
      <>
         <ImgEncabezado
            theme={theme}
            title="Imagenes encabezado para programa enterprise"
            status={status[0]}
            changeMode={val => changeMode(val, 0)}
            titleDesc="Descripción general Programa Enterprise"
            idUpdate={4}
            nameUpdate="Enterprise"
         />
         <Accordion theme={theme} title="lista de solicitantes" status={status[1]} changeMode={val => changeMode(val, 1)}>
            <ApplicantsTable theme={theme} />
         </Accordion>
      </>
   );
}
